
import Image from 'next/image';
import { SectionInfiniteCarouselProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import CarouselInfinite from '@/components/molecules/CarouselInfinite';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';

import { renderUnderline } from '@/utilities/functions';

const SectionInfiniteCarousel = ({ infiniteCarouselData }: { infiniteCarouselData: SectionInfiniteCarouselProps }) => {
	return (
		<>
			<Title_v2 underlineColor={infiniteCarouselData.title.underlineColor} align='center'>
				{renderUnderline(infiniteCarouselData.title.titlePieces)}
			</Title_v2>
			{infiniteCarouselData.description && (
				<Text textAlign='center'>
					{infiniteCarouselData.description}
				</Text>
			)}
			<CarouselInfinite backgroundColor={infiniteCarouselData.backgroundColor.color}>
				{infiniteCarouselData.infCarousels.data.map(
					(infiniteCarousel) => (
						infiniteCarousel.attributes.images.map(
							(imageAttributes, index) => (
								<Image
									alt={imageAttributes.source.data.attributes.alternativeText}
									key={index}
									placeholder={imageAttributes.isPlaceholderBlurred ? 'blur' : 'empty'}
									quality={100}
									loading='eager'
									src={imageAttributes.source.data.attributes.url}
									width={imageAttributes.source.data.attributes.width}
									height={imageAttributes.source.data.attributes.height}
								/>
							),
						)
					),
				)}
			</CarouselInfinite>
			{
				infiniteCarouselData.buttons.map(
					(button, index) => (
						<Button_v2
							gtm_id={button.trackerId}
							href={button.url}
							key={index}
							openOnNewTab={button.newTab}
							text={button.text}
							version={button.variant}
						/>
					),
				)
			}
		</>
	);
};

export default SectionInfiniteCarousel;
